export default {
	leaveAppeal: 'Zostaw wiadomość',
	requestACallback: 'Oddzwoń',
	email: 'Email',
	phone: 'Numer telefonu',
	name: 'Imię',
	appealMessage: 'Wiadomość',
	callback: 'Oddzwoń do mnie',
	enterYourMessage: 'Wpisz swoją wiadomość',
	invalidCharacters: 'Nieprawidłowe znaki',
	invalidPhoneBounds: 'Numer telefonu musi zawierać od 3 do 14 znaków',
	messageInvalidBounds: 'Wiadomość musi zawierać od 1 do 250 znaków',
	contacts: 'Kontakty',
	address: 'Adresy',
	web: 'Strona internetowa',
	writeEmail: 'Napisz do nas e-mail',
	callUs: 'Zadzwoń do nas',
	callWithWhatsApp: 'Kontakt za pomocą WhatsApp',
};
